/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_Users_Can_Deploy_AdditInputs */

const en_sovereign_users_can_deploy_addit = /** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign users can deploy additional storefronts on unique custom domains. Perfect for dedicated asset collections.`)
};

const id_sovereign_users_can_deploy_addit = /** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengguna Sovereign dapat menerapkan etalase tambahan di domain kustom unik. Sempurna untuk koleksi aset khusus.`)
};

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const es_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const fr_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const de_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const ja_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const zh_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const ar_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const it_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const ru_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const pt_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/** @type {(inputs: Sovereign_Users_Can_Deploy_AdditInputs) => LocalizedString} */
const ko_sovereign_users_can_deploy_addit = en_sovereign_users_can_deploy_addit;

/**
* | output |
* | --- |
* | "Sovereign users can deploy additional storefronts on unique custom domains. Perfect for dedicated asset collections." |
*
* @param {Sovereign_Users_Can_Deploy_AdditInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_users_can_deploy_addit = /** @type {((inputs?: Sovereign_Users_Can_Deploy_AdditInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_Users_Can_Deploy_AdditInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_users_can_deploy_addit(inputs)
	if (locale === "es") return es_sovereign_users_can_deploy_addit(inputs)
	if (locale === "fr") return fr_sovereign_users_can_deploy_addit(inputs)
	if (locale === "de") return de_sovereign_users_can_deploy_addit(inputs)
	if (locale === "ja") return ja_sovereign_users_can_deploy_addit(inputs)
	if (locale === "zh") return zh_sovereign_users_can_deploy_addit(inputs)
	if (locale === "ar") return ar_sovereign_users_can_deploy_addit(inputs)
	if (locale === "id") return id_sovereign_users_can_deploy_addit(inputs)
	if (locale === "it") return it_sovereign_users_can_deploy_addit(inputs)
	if (locale === "ru") return ru_sovereign_users_can_deploy_addit(inputs)
	if (locale === "pt") return pt_sovereign_users_can_deploy_addit(inputs)
	return ko_sovereign_users_can_deploy_addit(inputs)
});